import * as Yup from 'yup'

import { EulaType } from '../../types/privateOffer'

const enterQuantityMsg = 'Please enter quantity.'
const quantityNegativeMsg = 'Quantity cannot be negative.'
const quantityDecimalMsg = 'Quantity cannot take decimal values.'
const quantityMoreThan0Msg = 'Quantity should be greater than 0.'

export const freeTrialDimensionValidation = Yup.array().of(
  Yup.object().shape({
    type: Yup.string(),
    label: Yup.string().required(
      'Please choose at least one product dimension to proceed.'
    ),
    quantity: Yup.number()
      .typeError(enterQuantityMsg)
      .required(enterQuantityMsg)
      .positive(quantityNegativeMsg)
      .integer(quantityDecimalMsg)
      .min(1, quantityMoreThan0Msg),
  })
)

export const freeTrialValidation = Yup.object().shape({
  dimensions: freeTrialDimensionValidation,
  eulaType: Yup.string().required('EULA type is required.'),
  eulaFile: Yup.array().when('eulaType', {
    is: (eulaType: string) => eulaType === EulaType.CUSTOM,
    then: Yup.array()
      .required('EULA file is required when EULA type is custom.')
      .min(1, 'At least one EULA file is required.'),
    otherwise: Yup.array().optional().notRequired(),
  }),
  numberOfDays: Yup.number()
    .typeError('Number of days required.')
    .required('Number of days required.')
    .integer('Number of days cannot take decimal values')
    .min(7, 'Number of days should be between 7 and 90.')
    .max(90, 'Number of days should be between 7 and 90.'),
})
